var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"min-width":"310px","height":"400px","margin":"0 auto"}},[_c('highcharts',{attrs:{"options":_vm.chartOptions,"updateArgs":_vm.updateArgs}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }